var render, staticRenderFns
import script from "./CrtListPlans.vue?vue&type=script&lang=js&"
export * from "./CrtListPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75e4ff3f')) {
      api.createRecord('75e4ff3f', component.options)
    } else {
      api.reload('75e4ff3f', component.options)
    }
    
  }
}
component.options.__file = "src/views/Configuration/Plans/CrtListPlans.vue"
export default component.exports